import { createAction, props } from '@ngrx/store';
import { ICheckIn } from 'src/app/models/check-in';
import { IProxyGroup } from 'src/app/models/proxy-group';

export const SetCheckInObjectAction = createAction(
    '[Check-In] - Set Check-In Object',
    props<{ checkInObj: ICheckIn }>()
);

export const ClearCheckInObjectAction = createAction(
  '[Check-In] - Clear Check-In Object'
);

export const SetProxyObjectAction = createAction(
  '[Check-In-Proxy] - Set Check-In-Proxy Object',
  props<{ checkInProxyObj: ICheckIn[] }>()
);

export const ClearProxyObjectAction = createAction(
  '[Check-In-Proxy] - Clear Check-In-Proxy Object'
);

export const SetProxyGroupCheckInObjectAction = createAction(
  '[Check-In-Group-Proxy] - Set Check-In-Group-Proxy Object',
  props<{ checkInProxyGroupObj: IProxyGroup[] }>()
);

export const ClearProxyGroupCheckInObjectAction = createAction(
  '[Check-In-Group-Proxy] - Clear Check-In-Group-Proxy Object'
);
